import React, { useState, useCallback } from 'react';

// ** antd imports
import { Modal, Button } from 'antd';
import { ButtonType } from 'antd/lib/button';


type ActionContext = {
  close: (result?: any) => void;
};

type FooterAction = {
  key: string;
  label: React.ReactNode;
  type?: ButtonType
  danger?: boolean;
  onClick?: (ctx: ActionContext) => void | Promise<void>;
};

type ConfirmOptions = {
  title?: React.ReactNode;
  content?: React.ReactNode;
  closable?: boolean;
  maskClosable?: boolean;
  footer?: FooterAction[]; // 👈 custom footer
};

export function useConfirmModal() {
  const [visible, setVisible] = useState(false);
  const [options, setOptions] = useState<ConfirmOptions>({});
  const [resolver, setResolver] = useState<(value: any) => void>();

  const confirm = useCallback((opts: ConfirmOptions) => {
    setOptions(opts);
    setVisible(true);

    return new Promise<any>((resolve) => {
      setResolver(() => resolve);
    });
  }, []);

  const close = (result?: any) => {
    resolver?.(result);
    setVisible(false);
  };

  const renderFooter = () => {
    if (!options.footer) return null;

    return options.footer.map((action) => (
      <Button
        key={action.key}
        type={action.type}
        danger={action.danger}
        onClick={async () => {
          if (!action.onClick) return close(action.key);

          try {
            const maybePromise = action.onClick({
              close
            });

            if (maybePromise instanceof Promise) {
              await maybePromise;
            }
          } catch (err) {
            console.error(err);
          }
        }}
      >
        {action.label}
      </Button>
    ));
  };

  const modal = (
    <Modal
      title={options.title}
      visible={visible}
      onCancel={() => close(false)}
      footer={renderFooter()}
      closable={options.closable ?? true}
      maskClosable={options.maskClosable ?? false}
    >
      {options.content}
    </Modal>
  );

  return { confirm, modal };
}